import axios from "axios";
import {AddArticlePayload, UpdateArticlePayload} from "../pages/ArmatecaPage/ArmatecaArticle";

export const fetchArmatecaArticles = async (
  limit: number,
  nextPageToken?: string | null,
) => {
  const response = await axios.get(
    `${
      process.env.REACT_APP_BACKEND_URL
    }/armateka/preview/fetch?itemsPerPage=${limit}&PageToken=${nextPageToken ?? ""}`,
    {
      headers: {Authorization: `Bearer ${localStorage.getItem("authToken")}`},
    }
  );
  return response.data;
};

export const addArmatecaArticle = async (
  payload: AddArticlePayload
) => {
  const response = await axios.post(
    `${
      process.env.REACT_APP_BACKEND_URL
    }/armateka`,
    payload,
    {
      headers: {Authorization: `Bearer ${localStorage.getItem("authToken")}`},
    }
  );
  return response.data;
};


export const updateArmatecaArticle = async (
  payload: UpdateArticlePayload
) => {
  const response = await axios.put(
    `${
      process.env.REACT_APP_BACKEND_URL
    }/armateka`,
    payload,
    {
      headers: {Authorization: `Bearer ${localStorage.getItem("authToken")}`},
    }
  );
  return response.data;
};

export const changeArmatecaArticleStatus = async (
  payload: {
    ext_id: string,
    status: string
  }
) => {
  const response = await axios.put(
    `${
      process.env.REACT_APP_BACKEND_URL
    }/armateka/status`,
    payload,
    {
      headers: {Authorization: `Bearer ${localStorage.getItem("authToken")}`},
    }
  );
  return response.data;
};

export const getArticleById = async (
  id: string
) => {
  const response = await axios.get(
    `${
      process.env.REACT_APP_BACKEND_URL
    }/armateka?extID=${id}`,
    {
      headers: {Authorization: `Bearer ${localStorage.getItem("authToken")}`},
    }
  );
  return response.data;
};

export const uploadMedia = async (file: File) => {
  const response = await axios.post(
    `${
      process.env.REACT_APP_BACKEND_URL
    }/media`,
    {
      attachments: file
    },
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`
      },
    }
  );
  return response.data;
}
